import * as React from 'react';
import cx from 'classnames';

import './Link.styles.scss';

export class Link extends React.Component {
	render() {
		const { children, text, className, ...otherProps } = this.props;

		return (
			<a
				title={text || children}
				className={cx('Link', className)}
				{...otherProps}
			>
				{text || children}
			</a>
		);
	}
}